import momentJalaali from "moment-jalaali";

export function toEnglish(str) {
  str = str.toString();
  const persDigit = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const enDigit = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  for (let i = 0; i < persDigit.length; i++) {
    str = str.replace(new RegExp(persDigit[i], "g"), enDigit[i]);
  }
  return str;
}
export function separate(Number) {
  Number += "";
  Number = Number.replace(",", "");
  let x = Number.split(".");
  let y = x[0];
  let z = x.length > 1 ? "." + x[1] : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
  return y + z;
}
export function persianToEnglish(str) {
  str = str.toString();
  const persDigit = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const enDigit = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  for (let i = 0; i < persDigit.length; i++) {
    str = str.replace(new RegExp(persDigit[i], "g"), enDigit[i]);
  }
  return str;
}
export function toIsoString(date) {
  var tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num) {
      return (num < 10 ? "0" : "") + num;
    };
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    "00" +
    ":" +
    "00" +
    ":" +
    "00"
  );
}
export const UtcToMiladi = (date) => {
    //console.log('UtcToMiladi-1', date);
    //console.log('UtcToMiladi-2', Miladi2Shamsi(date.substring(0, 10)));
  if (date) {
    //const str = momentJalaali(date, "jYYYY/jM/jD")
    //  .format("jYYYY/jM/jD")
    //  .split("/");
    //const allData =
    //  str[0] + "-" + str[1]?.padStart(2, "0") + "-" + str[2]?.padStart(2, "0");
      //  return allData;
      return date.substring(0, 10);
  } else {
    return "";
  }
};
export function divideAndDisplay(result) {
  if (result % 10 === 0) {
    return result.toFixed(0);
  } else if (result.toString().length > 2) {
    return parseFloat(result.toFixed(2));
  } else {
    return result;
  }
}

function Miladi2Shamsi(miladi) {
    if (IsNullOrEmpty(miladi, null) === null)
        return null;
    if (miladi.length < 10)
        return null;
    var shamsi = Miladi2ShamsiDate(parseInt(miladi.substring(0, 4)), parseInt(miladi.substring(5, 7)), parseInt(miladi.substring(8, 10)));
    let res = shamsi[0].toString() + "/" + (shamsi[1] < 10 ? '0' : '') + shamsi[1].toString() + "/" + (shamsi[2] < 10 ? '0' : '') + shamsi[2].toString();
    if (miladi.length > 11 && miladi.substring(11, miladi.length) != '00:00:00')
        res += ' ' + miladi.substring(11, miladi.length);
    return res;
}

function IsNullOrEmpty(Value, NullValue) {
    if (Value == null)
        return NullValue;
    if (Value == '')
        return NullValue;
    return Value;
}

function Miladi2ShamsiDate(gy, gm, gd) {
    var g_d_m, jy, jm, jd, gy2, days;
    g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    gy2 = (gm > 2) ? (gy + 1) : gy;
    days = 355666 + (365 * gy) + ~~((gy2 + 3) / 4) - ~~((gy2 + 99) / 100) + ~~((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
    jy = -1595 + (33 * ~~(days / 12053));
    days %= 12053;
    jy += 4 * ~~(days / 1461);
    days %= 1461;
    if (days > 365) {
        jy += ~~((days - 1) / 365);
        days = (days - 1) % 365;
    }
    if (days < 186) {
        jm = 1 + ~~(days / 31);
        jd = 1 + (days % 31);
    } else {
        jm = 7 + ~~((days - 186) / 30);
        jd = 1 + ((days - 186) % 30);
    }
    return [jy, jm, jd];
}
